module.exports = __webpack_public_path__ + "img/RCservice.4a86593e.png";